// Module
var code = "<div id=\"columnSection\" ng-transclude></div> <kendo-grid id=\"grid\" k-options=\"options\" class=\"amt-grid\" k-rebind=\"rebind\"> </kendo-grid> <div ng-hide=\"hasData\"> No records </div> ";
// Exports
module.exports = code;